import { chakra } from '@chakra-ui/react';
import { Spinner } from '../primitives/Spinner';
import { Stack } from '../primitives/Layout';
import { Text } from '../primitives/Text';
import { Skeleton } from './Skeleton';

const Center = chakra('div', {
  base: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    gap: '3',
    py: '10',
    px: '6',
    textAlign: 'center',
  },
});

export interface LoadingStateProps {
  /** `spinner` for indeterminate waits, `skeleton` to mimic incoming content. */
  variant?: 'spinner' | 'skeleton';
  label?: string;
  /** Number of skeleton rows (skeleton variant). */
  rows?: number;
}

/** A standard busy state. Announces progress politely via role="status". */
export function LoadingState({ variant = 'spinner', label = 'Loading…', rows = 3 }: LoadingStateProps) {
  if (variant === 'skeleton') {
    return (
      <Stack gap="3" role="status" aria-live="polite" aria-busy="true">
        <chakra.span srOnly>{label}</chakra.span>
        {Array.from({ length: rows }).map((_, i) => (
          <Skeleton key={i} variant="text" width={i === rows - 1 ? '60%' : '100%'} />
        ))}
      </Stack>
    );
  }
  return (
    <Center role="status" aria-live="polite" aria-busy="true">
      <Spinner size="lg" tone="action" label={label} />
      {label && (
        <Text tone="muted" size="sm">
          {label}
        </Text>
      )}
    </Center>
  );
}
